import { IconPhone } from '@tabler/icons-react'

export const PERMISSION_SETS_CALLS = {
  id: 'Calls',
  description: 'Grant access to view, create, edit, and delete call logs.',
  icon: IconPhone,
  sections: [
    {
      title: 'permissions',
      permissions: [
        {
          type: 'checkbox',
          label: 'View, create, edit, and delete call logs',
        },
        {
          type: 'checkbox',
          label: `View others' call logs`,
        },
        {
          type: 'checkbox',
          label: `Delete others' call logs`,
        },
      ],
    },
  ],
}
